import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiGithub, FiTwitter, FiFacebook, FiMail, FiExternalLink } = FiIcons;

function Footer() {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'All Pokemon', path: '/pokemon' },
    { name: 'Pokemon Types', path: '/types' },
    { name: 'Compare Pokemon', path: '/compare' },
    { name: 'Top Rankings', path: '/top/fastest' }
  ];

  const topRankings = [
    { name: 'Fastest Pokemon', path: '/top/fastest' },
    { name: 'Strongest Pokemon', path: '/top/strongest' },
    { name: 'Bulkiest Pokemon', path: '/top/bulkiest' },
    { name: 'Best Defense', path: '/top/defensive' },
    { name: 'Highest Special Attack', path: '/top/special-attack' },
    { name: 'Highest Special Defense', path: '/top/special-defense' }
  ];

  const legalPages = [
    { name: 'About Us', path: '/about' },
    { name: 'Contact', path: '/contact' },
    { name: 'Terms of Service', path: '/terms' },
    { name: 'Privacy Policy', path: '/privacy' }
  ];

  return (
    <footer className="bg-gray-900 text-white" role="contentinfo">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <span className="text-2xl">⚡</span>
              <span className="text-xl font-bold">Pokemon Stats DB</span>
            </div>
            <p className="text-gray-400 text-sm">
              Complete Pokemon database with detailed statistics, abilities, types, and comparison tools. 
              Your ultimate Pokemon reference guide.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://twitter.com/example" 
                className="text-gray-400 hover:text-white transition-colors focus:ring-2 focus:ring-white rounded"
                aria-label="Follow us on Twitter"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SafeIcon icon={FiTwitter} className="w-5 h-5" />
              </a>
              <a 
                href="https://facebook.com/example" 
                className="text-gray-400 hover:text-white transition-colors focus:ring-2 focus:ring-white rounded"
                aria-label="Follow us on Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SafeIcon icon={FiFacebook} className="w-5 h-5" />
              </a>
              <a 
                href="https://github.com/example" 
                className="text-gray-400 hover:text-white transition-colors focus:ring-2 focus:ring-white rounded"
                aria-label="View source code on GitHub"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SafeIcon icon={FiGithub} className="w-5 h-5" />
              </a>
              <a 
                href="mailto:contact@example.com" 
                className="text-gray-400 hover:text-white transition-colors focus:ring-2 focus:ring-white rounded"
                aria-label="Send us an email"
              >
                <SafeIcon icon={FiMail} className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="text-gray-400 hover:text-white transition-colors text-sm focus:ring-2 focus:ring-white rounded"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Top Rankings */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Top Rankings</h3>
            <ul className="space-y-2">
              {topRankings.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="text-gray-400 hover:text-white transition-colors text-sm focus:ring-2 focus:ring-white rounded"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Information</h3>
            <ul className="space-y-2">
              {legalPages.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="text-gray-400 hover:text-white transition-colors text-sm focus:ring-2 focus:ring-white rounded"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link 
                  to="/sitemap.xml"
                  className="text-gray-400 hover:text-white transition-colors text-sm focus:ring-2 focus:ring-white rounded flex items-center space-x-1"
                >
                  <span>Sitemap</span>
                  <SafeIcon icon={FiExternalLink} className="w-3 h-3" />
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © {currentYear} Pokemon Stats Database. All rights reserved.
          </p>
          <p className="text-gray-400 text-sm">
            Pokemon and all related characters are trademarks of Nintendo, Game Freak, and The Pokemon Company.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;